import App from '#/App';
import '#/i18n';
import '#/index.css';
import reportWebVitals from '#/reportWebVitals';
import {createRoot} from 'react-dom/client';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
root.render(<App />);

if (import.meta.env.DEV) {
  reportWebVitals();
}
